(() => {
  'use strict';
  const config = document.getElementById('kw-config');
  const production = Boolean(config);
  const parsed = production ? JSON.parse(config.textContent) : null;
  const offerEndsAt = parsed?.endsAt ? Date.parse(parsed.endsAt) : null;
  function expireOffer() {
    if (!Number.isFinite(offerEndsAt)) return false;
    if (Date.now() <= offerEndsAt && !document.body.classList.contains('offer-ended')) return false;
    document.body.classList.add('offer-ended');
    document.getElementById('offer-ended-message').hidden = false;
    document.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
    return true;
  }
  if (expireOffer()) return;
  window.setInterval(expireOffer, 60000);
  const defaults = [
    {key:'zeus',name:'Zeus’s Stone',handle:'zeuss-stone-crystal-whiskey-glass',id:51162094272801,price:9599,available:true,image:'assets/zeus.webp',option:'Clear',copy:'Broad vertical facets and an angular base give this clear glass a sculptural presence. For whiskey, bourbon, cocktails over ice, or a distinctive place on your home bar.'},
    {key:'nova',name:'Nova Crest',handle:'nova-crest-crystal-whiskey-glass',id:53542713721121,price:9599,available:true,image:'assets/nova.webp',option:'Clear',copy:'Clean vertical cuts meet a deeply faceted base in this clear whiskey glass. Choose Nova Crest for a striking play of light on your home bar. Offered here in Clear.'},
    {key:'lens',name:'Lens',handle:'lens-crystal-whiskey-glass',id:49785435357473,price:8399,available:true,image:'assets/lens.webp',option:'Clear',copy:'Elongated lens-shaped facets and a geometric base give this clear glass its distinctive look. This four-glass edit offers Lens in Clear.'},
    {key:'star',name:'Star',handle:'star-crystal-whiskey-glass',id:50129074258209,price:9599,available:true,image:'assets/star.webp',option:'Clear',copy:'An intricate star-like lattice wraps a classic straight-sided silhouette. Choose Star for patterned glassware with a more traditional character.'}
  ];
  const recommended = defaults.map(p => ({...p,...parsed?.products?.find(v => v.key === p.key)}));
  const products = [...recommended];
  const collections = [
    {handle:'crystal-whiskey-glass',name:'Whiskey'},
    {handle:'spinning-whiskey-glasses',name:'Spinning'},
    {handle:'high-ball',name:'Highball'},
    {handle:'crystal-wine-glass',name:'Wine'},
    {handle:'crystal-sake-glass',name:'Sake'}
  ];
  const root = parsed?.root || '/';
  const currency = parsed?.currency || 'USD';
  const money = cents => new Intl.NumberFormat('en-US',{style:'currency',currency}).format(cents/100);
  const find = key => products.find(p => p.key === key);
  const $ = selector => document.querySelector(selector);
  const $$ = selector => Array.from(document.querySelectorAll(selector));
  const storageKey = 'kw-four-glass-mix-v3';
  const quantities = Object.fromEntries(products.map(p => [p.key,0]));
  let pending = false;
  let uncertain = false;
  let activeDetail = null;
  let returnFocus = null;
  let catalog = [];
  let catalogPromise = null;
  let catalogReady = false;
  let category = 'all';
  let restoreItems = [];
  let restoring = false;
  let checkoutVisible = false;
  const variantChoices = new Map();
  try {
    const previous = JSON.parse(localStorage.getItem('kw-four-glass-bestsellers-v2'));
    const saved = JSON.parse(localStorage.getItem(storageKey)) || recommended.map(p=>({id:p.id,quantity:previous?.[p.key] || 0}));
    let remaining = 4;
    if (Array.isArray(saved)) saved.slice(0,4).forEach(item=>{
      if (!Number.isSafeInteger(item.id) || !Number.isInteger(item.quantity) || item.quantity<1) return;
      const quantity=Math.min(item.quantity,remaining);
      const p=products.find(p=>p.id===item.id);
      if (p?.available) quantities[p.key]=(quantities[p.key]||0)+quantity;
      else if (!p) restoreItems.push({id:item.id,quantity});
      remaining-=quantity;
    });
    restoring=restoreItems.length>0;
  } catch {}
  const units = () => products.flatMap(p => Array.from({length:quantities[p.key]||0},() => p));
  const escape = s => String(s).replace(/[&<>"']/g,c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  function calculation() {
    const chosen = units();
    const subtotal = chosen.reduce((sum,p) => sum+p.price,0);
    const free = chosen.length === 4 && chosen.every(p=>p.available) ? chosen.reduce((a,b) => a.price <= b.price ? a : b) : null;
    return {chosen,subtotal,free,saving:free?.price || 0,total:subtotal-(free?.price || 0)};
  }
  function announcement(message) { $('#live-status').textContent = message; $('#picker-announcement').textContent = message; }
  function persist() {
    try {localStorage.setItem(storageKey,JSON.stringify(products.filter(p=>quantities[p.key]).map(p=>({id:p.id,quantity:quantities[p.key]}))));} catch {}
  }
  function track(action,extra={}) {
    if (production && Array.isArray(window.dataLayer)) window.dataLayer.push({event:'kw_four_glass_'+action,...extra});
  }
  function render() {
    const {chosen,subtotal,free,saving,total} = calculation();
    const count = chosen.length;
    const unavailable=chosen.filter(p=>!p.available);
    $('#selection-count').textContent = `${count} / 4`;
    $('#selection-title').textContent = unavailable.length?'Your set needs an update.':count === 4 ? 'Your set is ready.' : 'Your four-glass set';
    $('#selection-hint').textContent = unavailable.length?`${unavailable.map(p=>p.name).join(', ')} is unavailable. Remove it and choose a replacement.`:count === 4 ? `${free.name} is free. Add all four to your cart.` : count ? `Choose ${4-count} more ${count === 3 ? 'glass' : 'glasses'} to unlock your free one.` : 'Choose 4 glasses to unlock your free one.';
    $('.progress').setAttribute('aria-valuenow',count);
    $$('.progress span').forEach((el,i) => el.classList.toggle('filled',i<count));
    $('#subtotal').textContent = count ? money(subtotal) : '—';
    $('#saving').textContent = saving ? '−'+money(saving) : '—';
    $('#total').textContent = count ? money(total) : '—';
    $('#currency-label').textContent = currency;
    const checkout = $('#checkout');
    checkout.disabled = count !== 4 || pending || uncertain || restoring || chosen.some(p => !p.available);
    checkout.setAttribute('aria-busy',pending);
    $('.mobile-bar').classList.toggle('is-checkout-action-visible',checkoutVisible && !checkout.disabled);
    checkout.innerHTML = pending ? 'Adding your set…' : uncertain ? 'Check your cart before retrying' : count === 4 ? 'Add 4 to cart <span aria-hidden="true">↗</span>' : `Choose ${4-count} ${count ? 'more ' : ''}${count === 3 ? 'glass' : 'glasses'} to continue <span aria-hidden="true">↗</span>`;
    $('#mobile-count').textContent = count === 4 ? `${money(total)} ${currency}` : `Your set · ${count}/4`;
    $('#mobile-total').textContent = unavailable.length?'Replace the unavailable glass to continue':count === 4 ? `Save ${money(saving)} · before shipping & taxes` : count ? `Choose ${4-count} more · lowest-priced one free` : 'Mix eligible styles · lowest-priced one free';
    const mobile = $('#mobile-review');
    mobile.disabled = pending || restoring;
    mobile.setAttribute('aria-busy',pending);
    mobile.innerHTML = pending ? 'Adding…' : restoring ? 'Restoring…' : uncertain ? 'View cart ↗' : unavailable.length?'Replace glass ↗':count === 4 ? 'Add 4 to cart ↗' : 'Choose my four ↗';
    const presetSubtotal = recommended.reduce((sum,p)=>sum+p.price,0);
    const presetSaving = Math.min(...recommended.map(p=>p.price));
    $$('[data-preset-total]').forEach(el=>el.textContent=money(presetSubtotal-presetSaving));
    $$('[data-preset-subtotal]').forEach(el=>el.textContent=money(presetSubtotal));
    $$('[data-preset-saving]').forEach(el=>el.textContent=money(presetSaving));
    $$('[data-currency]').forEach(el=>el.textContent=currency);
    $$('[data-preset]').forEach(button=>button.disabled=pending||uncertain||restoring||recommended.some(p=>!p.available));
    $$('[data-open-picker]').forEach(button=>button.disabled=pending||uncertain);
    $('#detail-add').disabled = count === 4 || pending || uncertain || restoring || !find(activeDetail)?.available;
    recommended.forEach(p => {
      const amount = quantities[p.key]||0;
      const controls = $(`[data-controls="${p.key}"]`);
      if (amount) {
        if (!controls.querySelector('.quantity-control')) controls.innerHTML = `<div class="quantity-control"><button type="button" data-minus="${p.key}" aria-label="Remove one ${escape(p.name)}">−</button><span></span><button type="button" data-add="${p.key}" aria-label="Add one ${escape(p.name)}">+</button></div>`;
        controls.querySelector('span').textContent = amount;
        controls.querySelector('span').setAttribute('aria-label',`${amount} ${p.name} selected`);
        controls.querySelector('[data-add]').disabled = count === 4 || pending || uncertain || restoring || !p.available;
        controls.querySelector('[data-minus]').disabled = pending || uncertain || restoring;
      } else {
        if (!controls.querySelector('.add-button')) controls.innerHTML = `<button class="add-button" type="button" data-add="${p.key}">Select glass <span aria-hidden="true">+</span></button>`;
        controls.querySelector('button').disabled = count === 4 || pending || uncertain || restoring || !p.available;
        if (!p.available) controls.querySelector('button').textContent = 'Currently unavailable';
      }
      $(`[data-price="${p.key}"]`).textContent = money(p.price);
      $(`[data-product="${p.key}"]`).classList.toggle('is-selected',amount>0);
    });
    let freeUsed = false;
    const lines = products.filter(p => quantities[p.key]).map(p => {
      const isFree = free && p.key === free.key && !freeUsed;
      if (isFree) freeUsed = true;
      const quantity = quantities[p.key];
      return `<div class="selected-line${isFree?' free':''}${!p.available?' unavailable':''}"><img src="${escape(p.image)}" width="45" height="45" alt=""><div class="selected-line-name">${escape(p.name)} × ${quantity}<small>${!p.available?'UNAVAILABLE · ':isFree?'1 glass FREE · ':''}${escape(p.option)}</small><button class="line-remove" type="button" data-minus="${p.key}" ${pending||uncertain||restoring?'disabled':''} aria-label="Remove one ${escape(p.name)} ${escape(p.option)} from selection">Remove one</button></div><strong>${money(p.price*quantity-(isFree?p.price:0))}</strong></div>`;
    }).join('');
    $('#selected-lines').innerHTML = lines || '<div class="empty-selection"><p>Four places. Your choice.</p><span>Select a glass above, or start with one of each.</span></div>';
    $('#checkout-lines').innerHTML = lines.replace(/<button[\s\S]*?<\/button>/g,'').replace(/<strong>[\s\S]*?<\/strong>/g,'').replace(/1 glass FREE · /g,'').replace(/class="selected-line free"/g,'class="selected-line"');
    renderPickerSelection();
  }
  function change(key,delta) {
    if (expireOffer() || pending || uncertain || restoring) return;
    const p = find(key);
    if (!p || (delta>0 && (!p.available || units().length>=4))) return;
    const focused = document.activeElement;
    const fromSelection = Boolean(focused?.closest('#selected-lines'));
    quantities[key] = Math.max(0,quantities[key]+delta);
    restoreItems=[];
    $('#restore-status').hidden=true;
    $('#cart-error').hidden = true;
    render();
    persist();
    if (focused && !focused.isConnected) {
      const control = fromSelection ? $(`#selected-lines [data-minus="${key}"]`) : $(`[data-controls="${key}"] button:not(:disabled)`);
      (control || $(`#picker-grid [data-add="${key}"]:not(:disabled)`) || $(`#picker-slots [data-minus="${key}"]`) || $('#picker-done'))?.focus({preventScroll:true});
    }
    announcement(`${p.name} ${delta>0?'added':'removed'}. ${units().length} of 4 selected.`);
    track('select',{product_id:p.id,quantity:quantities[key]});
  }
  function showDialog(dialog) {
    returnFocus = document.activeElement;
    dialog.showModal();
  }
  function closeDialog(dialog) {
    dialog.close();
    if (returnFocus?.isConnected && !returnFocus.disabled) returnFocus.focus({preventScroll:true});
  }
  function pickerFeedback(message,{retry=false,fallback=false}={}) {
    $('#picker-feedback').hidden=!message;
    $('#picker-feedback-text').textContent=message;
    $('#picker-retry').hidden=!retry;
    $('.picker-fallback').hidden=!fallback;
  }
  function catalogVariant(group) {
    return find(variantChoices.get(group.id)) || find(group.keys.find(key=>find(key).available) || group.keys[0]);
  }
  async function catalogPage(handle,page=1) {
    const data=await request(`collections/${handle}?view=kw-b3g1-catalog&sort_by=best-selling&page=${page}`,{cache:'no-store'},true).catch(()=>{throw new Error('We could not load the glass collection. Please try again. Your selection is still here.');});
    if (!data) return [];
    if (data.currency!==currency || !Array.isArray(data.products) || !Number.isInteger(data.pages)) throw new Error('Your store currency or catalog has changed. Refresh this page to see current prices.');
    if (data.pages>20) throw new Error('The glass collection could not be fully loaded. Please try again.');
    if (page<data.pages) data.products.push(...await catalogPage(handle,page+1));
    return data.products.map(p=>({...p,category:handle}));
  }
  async function loadCatalog(refresh=false) {
    if (catalogPromise) return catalogPromise;
    if (catalogReady && !refresh) return;
    $('#picker-grid').setAttribute('aria-busy','true');
    if (!catalogReady) pickerFeedback('Loading eligible glasses and current prices…');
    catalogPromise=(async()=>{
      let items;
      if (production) items=(await Promise.all(collections.map(c=>catalogPage(c.handle)))).flat();
      else {
        const response=await fetch('assets/eligible-glasses-preview.json');
        if (!response.ok) throw new Error('The style preview could not load. Please try again.');
        items=(await response.json()).products;
      }
      if (expireOffer()) return;
      const groups=new Map();
      const seen=new Set();
      for (const item of items) {
        if (!Number.isSafeInteger(item.id) || !/^[a-z0-9-]+$/.test(item.handle) || !Array.isArray(item.variants) || !collections.some(c=>c.handle===item.category)) continue;
        let group=groups.get(item.id);
        if (!group) {
          group={id:item.id,name:item.name,handle:item.handle,options:item.options,keys:[],categories:[]};
          groups.set(item.id,group);
        }
        if (!group.categories.includes(item.category)) group.categories.push(item.category);
        for (const v of item.variants) {
          if (!Number.isSafeInteger(v.id) || !Number.isSafeInteger(v.price) || v.price<0 || typeof v.available!=='boolean' || !/^(?:https:)?\/\/(?:kingwares\.com\/cdn\/|cdn\.shopify\.com\/)/.test(v.image||'')) continue;
          const existing=products.find(p=>p.id===v.id);
          const p=existing || {key:String(v.id),id:v.id};
          const isRecommended=recommended.includes(p);
          Object.assign(p,{name:isRecommended?p.name:item.name.replace(/\s+(?:Crystal )?(?:Whiskey|Highball|Sake|Wine) Glass(?:es)?$/i,''),fullName:item.name,handle:item.handle,price:v.price,available:v.available,image:isRecommended?p.image:v.image,option:v.option==='Default Title'?(isRecommended?p.option:'Single glass'):v.option});
          if (!existing) {products.push(p);quantities[p.key]=0;}
          if (!group.keys.includes(p.key)) group.keys.push(p.key);
          seen.add(p.id);
        }
      }
      const rank=g=>{const i=recommended.findIndex(p=>p.handle===g.handle);return i<0?recommended.length:i;};
      catalog=[...groups.values()].filter(g=>g.keys.length).sort((a,b)=>rank(a)-rank(b));
      if (!catalog.length) throw new Error('No eligible glasses could be loaded. Please try again.');
      if (refresh) products.filter(p=>quantities[p.key]&&!seen.has(p.id)).forEach(p=>p.available=false);
      let dropped=false;
      for (const saved of restoreItems) {
        const p=products.find(p=>p.id===saved.id);
        if (p?.available && units().length<4) quantities[p.key]=Math.min(saved.quantity,4-units().length);
        else dropped=true;
      }
      restoreItems=[];restoring=false;catalogReady=true;
      $('#restore-status').hidden=!dropped;
      $('#restore-status').textContent=dropped?'Some saved glasses are no longer available. Please choose a replacement.':'';
      persist();
      renderCategories();renderCatalog();render();
    })().catch(e=>{
      restoring=false;
      pickerFeedback(e.message || 'We could not load the styles. Please try again.',{retry:true,fallback:true});
      $('#picker-result-count').textContent='Styles could not be loaded.';
      if (restoreItems.length) {
        $('#restore-status').hidden=false;
        $('#restore-status').textContent='Your other saved styles could not be restored. Open Choose other styles to retry, or start a new selection.';
      }
      render();
      throw e;
    }).finally(()=>{catalogPromise=null;$('#picker-grid').setAttribute('aria-busy','false');});
    return catalogPromise;
  }
  function renderCategories() {
    const tabs=[{handle:'all',name:'All styles'},...collections.filter(c=>catalog.some(g=>g.categories.includes(c.handle)))];
    if (!tabs.some(c=>c.handle===category)) category='all';
    $('#picker-categories').innerHTML=tabs.map(c=>`<a class="picker-tab" role="tab" href="#picker-panel" id="picker-tab-${c.handle}" data-category="${c.handle}" aria-controls="picker-panel" aria-selected="${c.handle===category}" tabindex="${c.handle===category?'0':'-1'}">${c.name}</a>`).join('');
    $('#picker-panel').setAttribute('aria-labelledby','picker-tab-'+category);
  }
  function selectCategory(handle) {
    category=handle;
    renderCategories();renderCatalog();$('.picker-scroll').scrollTo(0,0);
    $(`[data-category="${category}"]`).focus({preventScroll:true});
  }
  function renderCatalog() {
    if (!catalogReady) return;
    const matches=catalog.filter(g=>category==='all'||g.categories.includes(category));
    matches.sort((a,b)=>Number(b.keys.some(k=>find(k).available))-Number(a.keys.some(k=>find(k).available)));
    $('#picker-result-count').dataset.matches=matches.length;
    pickerFeedback(matches.length?'':'No eligible styles are available in this category. Choose another tab.');
    $('#picker-grid').innerHTML=matches.map(g=>{
      const p=catalogVariant(g);
      const optionLabel=(g.options||[]).filter(o=>o!=='Title').join(' / ') || 'Option';
      const categories=g.categories.map(h=>collections.find(c=>c.handle===h)?.name).join(' / ');
      return `<article class="picker-card" data-picker-product="${g.id}" aria-label="${escape(g.name)}"><div class="picker-card-image"><img src="${escape(p.image)}" alt="${escape(g.name)} — ${escape(p.option)}" width="480" height="480" loading="lazy">${recommended.some(r=>r.handle===g.handle)?'<span class="picker-badge">Bestseller</span>':''}</div><div class="picker-card-body"><p class="picker-card-category">${escape(categories)} · Single glass</p><h3>${escape(p.name)}</h3><p class="picker-card-price">${money(p.price)} <small>${currency}</small></p>${g.keys.length>1?`<label class="picker-option" for="picker-variant-${g.id}">${escape(optionLabel)}<select id="picker-variant-${g.id}" data-variant-product="${g.id}">${g.keys.map(k=>{const v=find(k);return `<option value="${k}"${k===p.key?' selected':''}${!v.available?' disabled':''}>${escape(v.option)}${!v.available?' — Sold out':''}</option>`;}).join('')}</select></label>`:''}<div class="picker-card-controls" data-picker-controls="${g.id}"></div><a class="picker-product-link" href="${production?root:'https://kingwares.com/'}products/${g.handle}?variant=${p.id}" target="_blank" rel="noopener" aria-label="View ${escape(g.name)} ${escape(p.option)} product details in a new tab">Product details <span aria-hidden="true">↗</span></a></div></article>`;
    }).join('');
    renderPickerSelection();
  }
  function renderPickerSelection() {
    const {chosen,subtotal,saving,total}=calculation();
    const locked=pending||uncertain||restoring;
    if (catalogReady) {
      const matches=Number($('#picker-result-count').dataset.matches);
      $('#picker-result-count').textContent=`${matches} ${matches===1?'style':'styles'} · ${chosen.length===4?'Remove a selected glass below to swap.':'Choose any 4 glasses.'}`;
    }
    $('#picker-count').textContent=`${chosen.length} / 4 selected`;
    $('#picker-total').textContent=chosen.length?`${money(total)} ${currency}`:'—';
    $('#picker-saving').innerHTML=chosen.some(p=>!p.available)?'Replace unavailable glasses to unlock your offer.':saving?`<span class="picker-before">${money(subtotal)} before offer · </span>Save ${money(saving)}`:chosen.length?`Choose ${4-chosen.length} more for your free glass.`:'Choose 4 to unlock your free glass.';
    $('#picker-done').innerHTML=chosen.length===4?'Review set <span aria-hidden="true">↗</span>':chosen.length?'Keep selection <span aria-hidden="true">↗</span>':'Back to page <span aria-hidden="true">↗</span>';
    $('#picker-slots').innerHTML=Array.from({length:4},(_,i)=>{
      const p=chosen[i];
      return p?`<div class="picker-slot filled"><img src="${escape(p.image)}" alt="" width="56" height="56"><div><strong>${escape(p.name)}</strong><span>${escape(p.option)}</span></div><button type="button" data-minus="${p.key}" aria-label="Remove one ${escape(p.name)} ${escape(p.option)} from your four" ${locked?'disabled':''}>×</button></div>`:`<div class="picker-slot empty"><span aria-hidden="true">${String(i+1).padStart(2,'0')}</span><span>Choose a glass</span></div>`;
    }).join('');
    for (const group of catalog) {
      const controls=$(`[data-picker-controls="${group.id}"]`);
      if (!controls) continue;
      const p=catalogVariant(group),amount=quantities[p.key]||0;
      if (controls.dataset.key!==p.key || controls.dataset.mode!==(amount?'quantity':'add')) {
        controls.dataset.key=p.key;controls.dataset.mode=amount?'quantity':'add';
        controls.innerHTML=amount?`<div class="quantity-control"><button type="button" data-minus="${p.key}" aria-label="Remove one ${escape(p.name)} ${escape(p.option)}">−</button><span></span><button type="button" data-add="${p.key}" aria-label="Add one ${escape(p.name)} ${escape(p.option)}">+</button></div>`:`<button type="button" class="add-button" data-add="${p.key}" aria-label="Select ${escape(p.name)} ${escape(p.option)}"><span>${p.available?'Select glass':'Sold out'}</span><span aria-hidden="true">${p.available?'+':'—'}</span></button>`;
      }
      controls.querySelector('[data-add]').disabled=locked||chosen.length>=4||!p.available;
      if (amount) {controls.querySelector('.quantity-control span').textContent=amount;controls.querySelector('[data-minus]').disabled=locked;}
      controls.closest('.picker-card').classList.toggle('is-selected',group.keys.some(k=>quantities[k]));
    }
  }
  function openPicker() {
    if (expireOffer() || pending || uncertain) return;
    showDialog($('#glass-picker'));
    track('browse_styles');
    loadCatalog().catch(()=>{});
  }
  function error(message,cartLink=false) {
    $('#cart-error').hidden=false;
    $('#cart-error').textContent=message;
    $('.recovery-link').hidden=!cartLink;
    $('#selection').scrollIntoView({behavior:'instant',block:'start'});
    $('#cart-error').tabIndex=-1;
    $('#cart-error').focus({preventScroll:true});
  }
  async function request(path,options={},allowMissing=false) {
    const response = await fetch(root+path,{credentials:'same-origin',signal:AbortSignal.timeout(20000),...options});
    if (allowMissing && response.status===404) return null;
    let data;
    try {data=await response.json();} catch {throw new Error('The store returned an unexpected response. Please review your cart before trying again.');}
    if (!response.ok) throw new Error(data.description || data.message || 'The store could not update your cart. Please review it and try again.');
    return data;
  }
  async function checkout() {
    if (expireOffer()) return;
    const chosen = calculation();
    if (chosen.chosen.length!==4 || pending || uncertain || restoring || chosen.chosen.some(p=>!p.available)) return;
    if (!production) {
      $('#checkout-summary').textContent = `${money(chosen.total)} ${currency} · ${money(chosen.saving)} saved`;
      const counts = products.filter(p=>quantities[p.key]).map(p=>`${p.id}:${quantities[p.key]}`).join(',');
      $('#continue-checkout').href=`https://kingwares.com/cart/${counts}?storefront=true`;
      showDialog($('#checkout-dialog'));
      return;
    }
    pending=true;
    $('#cart-error').hidden=true;
    $('.recovery-link').hidden=true;
    render();
    let writeStarted=false;
    try {
      const before=JSON.stringify(chosen.chosen.map(p=>[p.id,p.price,p.available]));
      if (chosen.chosen.some(p=>!recommended.includes(p))) await loadCatalog(true);
      const baseline=await request('cart.js');
      if (baseline.currency!==currency) throw new Error('Your store currency has changed. Refresh this page to see current prices before adding your glasses.');
      const current = await Promise.all(products.filter(p=>quantities[p.key]).map(async p => ({p,data:await request(`products/${p.handle}.js`)})));
      let changed=false;
      current.forEach(({p,data})=>{
        const v=data.variants.find(v=>v.id===p.id);
        if (!v || !v.available) {p.available=false; changed=true;}
        if (v && v.price!==p.price) {p.price=v.price;changed=true;}
      });
      if (changed || before!==JSON.stringify(calculation().chosen.map(p=>[p.id,p.price,p.available]))) {error('Price or availability has changed. Review the updated selection before continuing.');return;}
      if (expireOffer()) return;
      writeStarted=true;
      const items=products.filter(p=>quantities[p.key]).map(p=>({id:p.id,quantity:quantities[p.key]}));
      await request('cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
      uncertain=true;
      const cart=await request('cart.js');
      const selectedIds=new Set(chosen.chosen.map(p=>p.id));
      const hasOffer=cart.items.some(line=>selectedIds.has(line.variant_id) && (line.line_level_discount_allocations||[]).some(a=>a.discount_application?.title==='Special Offer' && a.amount>0));
      $('#checkout-kicker').textContent='ADDED TO YOUR KINGWARES CART';
      $('#checkout-title').textContent=hasOffer?'Your free glass is included.':'Please review your cart.';
      $('#checkout-summary').textContent=`Cart subtotal: ${money(cart.total_price)} ${cart.currency}`;
      $('#checkout-explanation').textContent=hasOffer?`Your four glasses were added. Your cart now contains ${cart.item_count} items, including any earlier selections. The Special Offer discount is applied. Shipping and taxes are calculated at checkout.`:'Your glasses were added, but we could not confirm the Special Offer discount. Open your cart to check the offer before paying. Please do not add the set again.';
      $('#continue-checkout').href=root+'cart';
      $('#continue-checkout').innerHTML='Review cart &amp; checkout <span aria-hidden="true">↗</span>';
      showDialog($('#checkout-dialog'));
      track('added',{item_count:4,currency,value:chosen.total/100});
    } catch(e) {
      if (writeStarted) uncertain=true;
      error(writeStarted?'We could not confirm the cart update. Open your cart to check before trying again; your glasses may already be there.':e.message,writeStarted);
    } finally {pending=false;render();}
  }
  document.addEventListener('click',event=>{
    const add=event.target.closest('[data-add]');
    const minus=event.target.closest('[data-minus]');
    const detail=event.target.closest('[data-detail]');
    const browse=event.target.closest('[data-open-picker]');
    const filter=event.target.closest('[data-category]');
    if (browse) openPicker();
    if (filter) {event.preventDefault();selectCategory(filter.dataset.category);}
    if (add) change(add.dataset.add,1);
    if (minus) change(minus.dataset.minus,-1);
    if (detail) {
      const p=find(detail.dataset.detail);activeDetail=p.key;
      $('#detail-title').textContent=p.name;$('#detail-copy').textContent=p.copy;
      $('#detail-image').src=p.image;$('#detail-image').alt=p.name+' — original product photograph';
      $('#detail-price').textContent=money(p.price)+' '+currency+' · '+p.option+' · Single glass';
      $('#detail-product-link').href=(production?root:'https://kingwares.com/')+'products/'+p.handle;
      $('#detail-feedback').textContent='';render();showDialog($('#detail-dialog'));
    }
    if (event.target.closest('.dialog-close,.dialog-close-text')) closeDialog(event.target.closest('dialog'));
  });
  $('#detail-add').addEventListener('click',()=>{change(activeDetail,1);$('#detail-feedback').textContent=`${units().length} of 4 selected. Close to keep choosing.`;});
  const scrollTo = target => target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
  $$('[data-preset]').forEach(button=>button.addEventListener('click',()=>{
    if(expireOffer()||pending||uncertain||restoring||recommended.some(p=>!p.available))return;
    products.forEach(p=>quantities[p.key]=0);
    recommended.forEach(p=>quantities[p.key]=1);
    restoreItems=[];
    $('#cart-error').hidden=true;
    render();
    persist();
    announcement('One of each selected. Your four-glass set is ready. The lowest-priced glass is free.');
    track('one_each');
    scrollTo($('#collection'));
  }));
  $('#checkout').addEventListener('click',checkout);
  $('#mobile-review').addEventListener('click',()=>{
    if(uncertain){window.location.href=production?root+'cart':'https://kingwares.com/cart';return;}
    if(units().length===4 && units().every(p=>p.available)){checkout();return;}
    openPicker();
  });
  $('#picker-categories').addEventListener('keydown',event=>{
    const tabs=$$('#picker-categories [role="tab"]');
    const index=tabs.indexOf(event.target);
    if (index<0) return;
    const next={ArrowRight:(index+1)%tabs.length,ArrowLeft:(index-1+tabs.length)%tabs.length,Home:0,End:tabs.length-1}[event.key];
    if (next!==undefined) {event.preventDefault();selectCategory(tabs[next].dataset.category);}
    else if (event.key===' ') {event.preventDefault();selectCategory(event.target.dataset.category);}
  });
  $('#picker-retry').addEventListener('click',()=>loadCatalog(true).catch(()=>{}));
  $('#picker-done').addEventListener('click',()=>{closeDialog($('#glass-picker'));if(units().length) scrollTo($('#selection'));});
  $('#picker-grid').addEventListener('change',event=>{
    const select=event.target.closest('[data-variant-product]');
    if (!select) return;
    const group=catalog.find(g=>g.id===Number(select.dataset.variantProduct));
    if (!group?.keys.includes(select.value)) return;
    variantChoices.set(group.id,select.value);
    const p=find(select.value),card=select.closest('.picker-card');
    card.querySelector('img').src=p.image;
    card.querySelector('img').alt=group.name+' — '+p.option;
    card.querySelector('.picker-card-price').innerHTML=`${money(p.price)} <small>${currency}</small>`;
    card.querySelector('.picker-product-link').href=(production?root:'https://kingwares.com/')+'products/'+p.handle+'?variant='+p.id;
    card.querySelector('.picker-product-link').setAttribute('aria-label',`View ${group.name} ${p.option} product details in a new tab`);
    renderPickerSelection();
  });
  $$('dialog').forEach(dialog=>{
    dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)closeDialog(dialog);}});
    dialog.addEventListener('cancel',()=>{if(returnFocus?.isConnected)returnFocus.focus();});
    dialog.addEventListener('keydown',event=>{
      if(event.key!=='Tab')return;
      const focusable=Array.from(dialog.querySelectorAll('button:not(:disabled),a[href],input:not(:disabled),select:not(:disabled),[tabindex="0"]')).filter(el=>el.tabIndex>=0 && el.getClientRects().length && getComputedStyle(el).visibility!=='hidden');
      const target=event.shiftKey && document.activeElement===focusable[0]?focusable.at(-1):!event.shiftKey && document.activeElement===focusable.at(-1)?focusable[0]:null;
      if(target){event.preventDefault();target.focus({preventScroll:true});}
    });
  });
  if(production){
    $$('.brand,.footer-brand').forEach(a=>a.href=root);
    $('.cart-link').href=root+'cart';$('.recovery-link').href=root+'cart';
  }
  render();
  if (restoring) {
    $('#restore-status').hidden=false;
    $('#restore-status').textContent='Restoring your saved styles and checking current prices…';
    loadCatalog().catch(()=>{});
  }
  if ('IntersectionObserver' in window) {
    const heroActionObserver = new IntersectionObserver(([entry]) => {
      $('.mobile-bar').classList.toggle('is-hero-action-visible', entry.isIntersecting);
    }, {threshold:0});
    heroActionObserver.observe($('.hero-actions'));
    const checkoutObserver=new IntersectionObserver(([entry])=>{
      checkoutVisible=entry.intersectionRatio>=0.99;
      $('.mobile-bar').classList.toggle('is-checkout-action-visible',checkoutVisible && !$('#checkout').disabled);
    },{threshold:[0,0.99]});
    checkoutObserver.observe($('#checkout'));
  }
})();
